import {
  WORK_AREA_DATA_SOURCE_KINDS,
  type WorkAreaDataSourceRegistry,
  workAreaDataSourceRegistry,
} from './WorkAreaDataSourceRegistry';

/**
 * Whether a cloud work area is reached through the desktop's native gateway (a desktop binding).
 * T-0770 (LC-6b): its own module, so the realtime layer the launch opens asks it without carrying
 * the work-item data sources, and with them the work-item API, in the entry.
 */
export function usesNativeCloudGateway(
  projectId: string,
  registry: WorkAreaDataSourceRegistry = workAreaDataSourceRegistry,
): boolean {
  const descriptor = registry.descriptor(projectId);
  return (
    descriptor?.kind === WORK_AREA_DATA_SOURCE_KINDS.cloud &&
    Boolean(descriptor.desktopBinding?.desktopWorkAreaId)
  );
}
